import { cva, cx } from '@vizit/theme';
import type { VerticalNavbarProps } from './types';
import { VerticalNavbarBanner } from './vertical-navbar-banner';
import { VerticalNavbarItem } from './vertical-navbar-item';
import { VerticalNavbarLogo } from './vertical-navbar-logo';
import { VerticalNavbarOrgBadge } from './vertical-navbar-org-badge';
import { VerticalNavbarUserMenu } from './vertical-navbar-user-menu';

const styles = {
  nav: cva({
    base: ['flex flex-col items-center shrink-0', 'w-26 h-full', 'bg-primary border-r border-secondary', 'py-12 px-6'],
  }),
  section: cva({ base: 'flex flex-col items-center gap-16' }),
  itemList: cva({ base: 'flex flex-col items-center gap-1' }),
  spacer: cva({ base: 'flex-1' }),
};

function VerticalNavbar(props: VerticalNavbarProps) {
  const {
    items,
    menuItems,
    userEmail,
    avatarColor,
    appVersion,
    organization,
    className,
    ref,
    'aria-label': ariaLabel = 'Main navigation',
  } = props;

  return (
    <nav ref={ref} className={cx(styles.nav(), className)} aria-label={ariaLabel}>
      <div className={styles.section()}>
        <VerticalNavbarLogo />

        <div className={styles.section()}>
          {organization && (
            <VerticalNavbarOrgBadge
              name={organization.name}
              backgroundColor={organization.backgroundColor}
              textColor={organization.textColor}
            />
          )}

          <ul className={styles.itemList()}>
            {items.map((item) => (
              <li key={item.key}>
                <VerticalNavbarItem
                  to={item.to}
                  label={item.label}
                  icon={item.icon}
                  isActive={item.isActive}
                  data-testid={`nav-${item.key}`}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className={styles.spacer()} aria-hidden="true" />

      <VerticalNavbarUserMenu
        menuItems={menuItems}
        userEmail={userEmail}
        avatarColor={avatarColor}
        appVersion={appVersion}
      />
    </nav>
  );
}

VerticalNavbar.Banner = VerticalNavbarBanner;
VerticalNavbar.Logo = VerticalNavbarLogo;
VerticalNavbar.OrgBadge = VerticalNavbarOrgBadge;
VerticalNavbar.Item = VerticalNavbarItem;
VerticalNavbar.UserMenu = VerticalNavbarUserMenu;

export { VerticalNavbar };
